import JournalFeedThumb from './JournalFeedThumb';
import JournalFeedThumbContainer from './JournalFeedThumb.container';

export default JournalFeedThumbContainer(JournalFeedThumb);
// export default JournalFeedThumb;
